import { render, staticRenderFns } from "./process.vue?vue&type=template&id=57e52e2a&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"
import style0 from "./process.vue?vue&type=style&index=0&id=57e52e2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e52e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57e52e2a')) {
      api.createRecord('57e52e2a', component.options)
    } else {
      api.reload('57e52e2a', component.options)
    }
    module.hot.accept("./process.vue?vue&type=template&id=57e52e2a&scoped=true", function () {
      api.rerender('57e52e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/crud/process.vue"
export default component.exports